// extracted by mini-css-extract-plugin
module.exports = {"wrap":"breadcrumbs_wrap__A8_5y"};